import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./esgBaseQuery";

export const BASE_METRICS_API_REDUCER_KEY = "esg-moduleApi";

export const esgmoduleactivites = createApi({
  reducerPath: BASE_METRICS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["esg-module"],
  endpoints: (builder) => ({
    getBaseMetricsList: builder.query({
      query: () => {
        return {
          url: `/v1/metric-master`,
        };
      },
      providesTags: ["esg-module"],
    }),
    getenvironmentMetricsList: builder.query({
      query: () => {
        return {
          url: `/v1/dashboard/environmental`,
        };
      },
      providesTags: ["esg-module"],
    }),
    // /v1/dashboard/environmental'
    getorganisationMetricsList: builder.query({
      query: (nodeID) => {
        return {
          url: `/v1/hierarchical-metrics/${nodeID}`,
        };
      },
      providesTags: ["esg-module"],
    }),
    // /v1/hierarchical-metrics/512'
    getstandardsList: builder.query({
      query: () => {
        return {
          url: `/v1/standards`,
        };
      },
      providesTags: ["esg-module"],
    }),
    getcategoryList: builder.query({
      query: () => {
        return {
          url: `/v1/categories`,
        };
      },
      providesTags: ["esg-module"],
    }),
    getFormList: builder.query({
      query: (report_id) => {
        return {
          url: `/v1/details/${report_id}`,
        };
      },
      providesTags: ["esg-module"],
    }),

    getalldocuments: builder.query({
      query: (report_id) => {
        return {
          url: `/v1/documents/all/`,
          headers: {
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI1MTIxOTlmYi1kY2E0LTQyNjItOTAzZC1jMzg5OWQ2NDU3NmQiLCJlbWFpbCI6InZhdGhzYWx5YUBrYXJib253aXNlLmNvbSIsInJvbGUiOiJTdXBlciBBZG1pbiIsInRlbmFudF9pZCI6InN0YWdlIiwiZXhwIjoxNzQxMjQyMDIzfQ.gAiw3VCo-GciZdHzP1BsJYVRP24H5ib4vqLpO78S2CE`,
            "X-Tenant-Id": "stage",
          },
        };
      },
      providesTags: ["esg-module"],
    }),

    AddMetricsList: builder.mutation({
      query: (metricsData) => ({
        url: "/v1/metric-master/",
        method: "POST",
        body: metricsData,
      }),
      invalidatesTags: ["esg-module"],
    }),


    Getunits: builder.query({
      query: () => {
        return {
          url: `/v1/units/`,
        };
      },
      providesTags: ["esg-module"],
    }),

    getRequestList: builder.query({
      query: () => {
        return {
          url: `/v1/debug/form-tokens-with-reports`,
        };
      },
      providesTags: ["esg-module"],
    }),
    getsubmittedBaseMetricsList: builder.query({
      query: (metric_id) => {
        return {
          url: `/v1/submit-data/${metric_id}`,
        };
      },
      providesTags: ["esg-module"],
    }),
    configmetricList: builder.mutation({
      query: ({ metric_id, payload }) => ({
        url: `/v1/metric-master/${metric_id}/fields`,
        method: "POST",
        body: payload,

      }),
      invalidatesTags: ["esg-module"],
    }),

    submitBaseMetrics: builder.mutation({
      query: (payload) => ({
        url: `/v1/submit-data`,
        method: "POST",
        body: payload,
        formData: true,
      }),
      invalidatesTags: ["esg-module"],
    }),

    submitrequestemailMetrics: builder.mutation({
      query: (payload) => ({
        url: `/v1/send-form-link`,
        method: "POST",
        body: payload,
      }),
      providesTags: ["esg-module"],
    }),
    requestemailMetrics: builder.query({
      query: (id) => {
        return {
          url: `/v1/form/${id}/metrics`, // Dynamically inserting form ID
        };
      },
      providesTags: ["esg-module"],
    }),

    getdocumentsMetrics: builder.query({
      query: (id) => {
        return {
          url: `/v1/documents/metric/${id}`, // Dynamically inserting form ID
        };
      },
      providesTags: ["esg-module"],
    }),

    submitFormMetrics: builder.mutation({
      query: ({ id, payload }) => {
        return {
          url: `/v1/form/${id}/submit-with-files`,
          method: "POST",
          body: payload, // payload is already a FormData object
        };
      },
      invalidatesTags: ["esg-module"],
    }),

    submitApprove: builder.mutation({
      query: ({ report_id }) => {
        return {
          url: `/v1/reports/${report_id}/approve`,
          method: "POST",
        };
      },
      invalidatesTags: ["esg-module"],
    }),
    rejectApprove: builder.mutation({
      query: ({ report_id }) => {
        return {
          url: `/v1/reports/${report_id}/reject`,
          method: "POST",
        };
      },
      invalidatesTags: ["esg-module"],
    }),
  }),
});

export const {
  useGetBaseMetricsListQuery,
  useGetstandardsListQuery,
  useGetcategoryListQuery,
  useGetFormListQuery,
  useGetRequestListQuery,
  useGetorganisationMetricsListQuery,
  useSubmitApproveMutation,
  useConfigmetricListMutation,
  useRejectApproveMutation,
  useAddMetricsListMutation,
  useGetsubmittedBaseMetricsListQuery,
  useSubmitBaseMetricsMutation,
  useGetunitsQuery,
  useSubmitFormMetricsMutation,
  useGetdocumentsMetricsQuery,
  useGetenvironmentMetricsListQuery,
  useGetalldocumentsQuery,
  useSubmitrequestemailMetricsMutation,
  useRequestemailMetricsQuery,
} = esgmoduleactivites;
